const STORAGE_KEY = 'store-locator';

export function getStoreLocatorState() {
  return window.theme?.storageUtil?.get(STORAGE_KEY, true) ?? {};
}

export function saveShopLocation(shop) {
  const state = getStoreLocatorState();
  state.shop = shop;
  window.theme.storageUtil.set(STORAGE_KEY, state);
}

export function saveDeliveryLocation(delivery) {
  const state = getStoreLocatorState();
  state.delivery = delivery;
  window.theme.storageUtil.set(STORAGE_KEY, state);
}

export function getShopLocation() {
  return getStoreLocatorState().shop ?? null;
}

export function getDeliveryLocation() {
  return getStoreLocatorState().delivery ?? null;
}

export function clearDeliveryLocation() {
  const state = getStoreLocatorState();
  delete state.delivery;
  window.theme.storageUtil.set(STORAGE_KEY, state);
}
